// import { useState, useEffect } from 'react'
// import { useLogin, useTranslate, useNavigation } from '@pankod/refine-core'
// import { Menu, Grid, Icons, useMenu } from '@pankod/refine-antd'

// import { Row, Col, AntdLayout, Card, Typography, Form, Input, Button, Checkbox } from '@pankod/refine-antd'
// import './style.less'

// const { Text, Title } = Typography
// export interface ILoginForm {
//   username: string
//   password: string
// }

// export const LoginPage: React.FC = () => {
//   const [form] = Form.useForm<ILoginForm>()
//   const [authError, setAuthError] = useState('')
//   const t = useTranslate()

//   const { mutate: login, isError, error } = useLogin<ILoginForm>()

//   const CardTitle = (
//     <div style={{ textAlign: 'center' }}>
//       <img style={{ width: '150px' }} src="/images/logo.jpg" width="100%" />
//     </div>
//   )

//   useEffect(() => {
//     if (isError) setAuthError(error.message)
//   }, [isError])

//   return (
//     <AntdLayout>
//       <Row
//         justify="center"
//         align="middle"
//         style={{
//           height: '100vh',
//         }}
//       >
//         <Col xs={22}>
//           <div style={{ maxWidth: '408px', margin: 'auto' }}>
//             <Card title={CardTitle} headStyle={{ borderBottom: 0 }}>
//               <Form<ILoginForm>
//                 layout="vertical"
//                 form={form}
//                 onFinish={values => {
//                   const value = login(values)
//                 }}
//                 requiredMark={false}
//               >
//                 <Form.Item name="username" label={t('pages.login.email', 'Username')} rules={[{ required: true }]}>
//                   <Input placeholder="admin@centa.org" />
//                 </Form.Item>
//                 <Form.Item
//                   name="password"
//                   label={'Password'}
//                   rules={[{ required: true, message: 'enter password' }]}
//                   style={{ marginBottom: '12px' }}
//                 >
//                   <Input type="password" placeholder="***********" onFocus={() => setAuthError('')} />
//                 </Form.Item>
//                 {authError && <p style={{ color: 'red', margin: '0px' }}>{authError}</p>}
//                 <div style={{ marginBottom: '12px' }}>
//                   <a
//                     style={{
//                       float: 'right',
//                       fontSize: '12px',
//                       marginBottom: '12px',
//                     }}
//                     href="/resetpassword"
//                   >
//                     Forgot password?
//                   </a>
//                 </div>
//                 <Button type="primary" size="large" htmlType="submit" block>
//                   {t('pages.login.signin', 'Sign in')}
//                 </Button>
//               </Form>
//             </Card>
//           </div>
//         </Col>
//       </Row>
//     </AntdLayout>
//   )
// }

//------------------------------------------------------------------------centa--------------------

import { useState, useEffect } from 'react'
import { useLogin, useTranslate, useNavigation } from '@pankod/refine-core'
import { Menu, Grid, Icons, useMenu,message } from '@pankod/refine-antd'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'

import { Row, Col, AntdLayout, Card, Typography, Form, Input, Button, Checkbox } from '@pankod/refine-antd'
import './style.less'

const { Text, Title } = Typography
export interface ILoginForm {
  username: string
  password: string
}

export const LoginPage: React.FC = () => {
  const [form] = Form.useForm<ILoginForm>()
  const [authError, setAuthError] = useState('')

  const t = useTranslate()
  const navigation = useNavigation()

  const { mutate: login, isError, error } = useLogin<ILoginForm>()

  const CardTitle = (
    <div style={{ textAlign: 'center' }}>
      <img style={{ width: '150px' }} src="/images/logo.jpg" width="100%" />
    </div>
  )

  const verifyUserLogged = async () => {
    const token = await localStorage.getItem('nhostRefreshToken')
    if (token) navigation.push('/')
  }

  useEffect(() => {
    if (isError){
      setAuthError(error.message)
      message.error("invalid email or password")
    } 
    verifyUserLogged()
  }, [isError])

  return (
    <AntdLayout>
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <div style={{ maxWidth: '408px', margin: 'auto' }}>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }} style={{ border: 'none', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
              {/* {authError && <p style={{ color: 'red', margin: 'center', textAlign: 'center' }}>{authError}</p>} */}
              <Form<ILoginForm>
                layout="vertical"
                form={form}
                onFinish={values => {
                  const value = login(values)
                  
                }}
                requiredMark={false}
              >
                <Form.Item
                  name="username"
                  label={t('pages.login.email', 'Email')}
                  rules={[
                    { required: true, message: 'Please enter your email' },
                    { whitespace: true, message: 'Please avoid adding white spaces' },
                    { type: 'email', message: 'Add an valid email' },
                  ]}
                  hasFeedback
                >
                  <Input placeholder="admin@centa.org" style={{ height: '40px' }} />
                </Form.Item>
                <Form.Item
                  name="password"
                  label={'Password'}
                  rules={[
                    { required: true, message: 'Please enter your password' },
                    { min: 4, message: 'Must be at least 4 characters long' },
                    { max: 20, message: 'Cannot exceed 20 characters' },
                  ]}
                  hasFeedback
                  style={{ marginBottom: '12px' }}
                >
                  <Input.Password placeholder="***********" onFocus={() => setAuthError('')} style={{ height: '40px' }} />
                </Form.Item>

                <div style={{ marginBottom: '12px' }}>
                  <a
                    style={{
                      float: 'right',
                      fontSize: '12px',
                      marginBottom: '12px',
                      color: 'black',
                    }}
                    href="/resetpassword"
                  >
                    Forgot password?
                  </a>
                </div>
                <Button type="primary" size="large" htmlType="submit" className="gradient-button" block>
                  {t('pages.login.signin', 'Sign In')}
                </Button>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  )
}

